import { render } from "./addPhoto.html?vue&type=template&id=23bd9cc5&scoped=true&ts=true&external"
import script from "./AddPhoto.vue?vue&type=script&lang=ts"
export * from "./AddPhoto.vue?vue&type=script&lang=ts"

import "./AddPhoto.vue?vue&type=style&index=0&id=23bd9cc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd9cc5"]])

export default __exports__